module.exports = __webpack_public_path__ + "img/not-found-large-size.dc78e1c.png";